<template>
  <div class="ds-control mobile ds_teas_batch_occupation_form">
    <div class="form_top">
      <div class="top_place">
        <div class="place_label">
          <span>*</span>占用地点
        </div>
        <div class="place_value" @click="showSelectField=true">
          <p v-if="place">{{place}}</p>
          <span v-else>请选择</span>
          <i class="iconfont icon-icon_more"></i>
        </div>
      </div>
      <DsfMobileTextbox v-model="reason" label="占用事由" fromDirection="vertical" inputAlign="left" :required="true">
      </DsfMobileTextbox>
    </div>
    <div class="form_content">
      <DsfMobileDateIntervalPicker v-model="date" labelS="占用日期" fromDirection="vertical" inputAlign="left" :required="true" @change="dateChange">
      </DsfMobileDateIntervalPicker>
      <DsfMobileTextbox v-model="contact_text" label="联系人" fromDirection="vertical" inputAlign="left">
      </DsfMobileTextbox>
      <DsfMobileTextbox v-model="phone" label="联系电话" fromDirection="vertical" inputAlign="left">
      </DsfMobileTextbox>
      <div class="content_checkbox">
        <p><span>*</span>重复设置</p>
        <div class="checkbox_item">
          <div v-for="(item,index) of weekArr" :key="index" :class="[item.check?'choose_check':'',item.readOnly?'read_only':'']" @click="chooseWeek(item,index)">{{item.text}}</div>
        </div>
      </div>
      <div class="content_time">
        <p>占用时间段</p>
        <div class="time_box" v-for="(item,index) of timeArr" :key="index">
          <div class="time_s" @click="selectTime('start',index)">{{item.stime}}</div>
          <span>-</span>
          <div class="time_e" @click="selectTime('end',index)">{{item.etime}}</div>
          <i class="iconfont icon-delete" @click="deleteTime(item,index)"></i>
        </div>
        <div class="add_time" @click="addTime">
          <i class="iconfont icon-hao"></i>
          <span>新增时间段</span>
        </div>
      </div>
    </div>
    <div class="btn_zw"></div>
    <div class="btn">
      <div class="btn_fh" @click="$router.go(-1)">返回</div>
      <div class="btn_qd" @click="sumbit">确定</div>
    </div>
    <van-popup v-model="showTime" position="bottom">
      <van-datetime-picker v-model="currentTime" type="time" title="选择时间" @cancel="showTime=false" @confirm="confirmTime" />
    </van-popup>
    <dsf-mobile-select-field :select-all="false" :show="showSelectField" :isCheckbox="true" @close="showSelectField=false" @choose-data="chooseData"></dsf-mobile-select-field>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileBatchOccupationForm",
  ctrlCaption: "批量占用表单页面",
  mixins: [$mixins.control],
  data() {
    return {
      reason: '',
      date: {
        sdate: '',
        edate: ''
      },
      place: '',
      placeArr: [],
      contact_text: '',
      phone: '',
      repeat: [],
      weekArr: [{
        text: '周一',
        value: '2',
        check: false,
        readOnly: false,
        weekId: 1
      }, {
        text: '周二',
        value: '3',
        check: false,
        readOnly: false,
        weekId: 2
      }, {
        text: '周三',
        value: '4',
        check: false,
        readOnly: false,
        weekId: 3
      }, {
        text: '周四',
        value: '5',
        check: false,
        readOnly: false,
        weekId: 4
      }, {
        text: '周五',
        value: '6',
        check: false,
        readOnly: false,
        weekId: 5
      }, {
        text: '周六',
        value: '7',
        check: false,
        readOnly: false,
        weekId: 6
      }, {
        text: '周日',
        value: '1',
        check: false,
        readOnly: false,
        weekId: 0
      }],
      weekValue: [],
      timeArr: [
        {
          stime: '',
          etime: ''
        }
      ],
      showTime: false,
      currentTime: '',
      timeIndex: '',
      timeKey: '',
      showSelectField: false,
    }
  },
  props: {
    sourcesUrl: {
      type: String,
      default: '/resource/occupy/batchOccupy',
    }
  },
  methods: {
    chooseWeek(item, index) {
      if (item.readOnly) return
      this.weekArr[index].check = !this.weekArr[index].check;
    },
    addTime() {
      this.timeArr.push({
        stime: '',
        etime: ''
      })
    },
    deleteTime(item, index) {
      this.timeArr.splice(index, 1);
    },
    selectTime(key, index) {
      this.timeKey = key;
      this.timeIndex = index;
      this.showTime = true;
    },
    // 确认选中时间
    confirmTime(val) {
      let key = this.timeKey == 'start' ? 'stime' : 'etime';
      this.timeArr[this.timeIndex][key] = val;
      this.showTime = false;
    },
    chooseData(val) {
      console.log(val);
      let arr = [];
      val.forEach(element => {
        arr.push(element.inheritName)
      });
      this.placeArr = val;
      this.place = arr.join('、');
      this.showSelectField = false;
    },
    dateChange() {
      let startDate = new Date(this.date.sdate);
      let endDate = new Date(this.date.edate);
      var result = {};
      var start = startDate.getTime();
      var end = endDate.getTime()
      for (var i = start; i <= end; i += 86400000) {
        var week = new Date(i).getDay();
        if (!result[week]) {
          result[week] = week;
        }
      }
      this.weekArr.forEach(element => {
        element.check = false;
        if (element.weekId == result[element.weekId]) {
          element.readOnly = false;
        } else {
          element.readOnly = true;
        }
      });
    },
    sumbit() {
      if (!this.place) {
        dsf.layer.message('请选择占用地点', false)
        return
      }
      if (!this.reason) {
        dsf.layer.message('请填写占用事由', false)
        return
      }
      if (!this.date.sdate || !this.date.edate) {
        dsf.layer.message('请选择占用日期', false)
        return
      }
      let isCf = this.weekArr.every(elemnt => {
        return !elemnt.check
      })
      if (isCf) {
        // dsf.layer.message('请选择重复星期', false)
        return
      }
      let isTimeErr = this.timeArr.every(element => {
        if (element.stime && element.etime) {
          let start = element.stime.split(':');
          let end = element.etime.split(':');
          return start[0] < end[0] || (start[0] == end[0] && start[1] < end[1])
        } else {
          return false
        }
      })
      if (!isTimeErr) {
        dsf.layer.message('占用时间段有误', false)
        return
      }
      let reg_phone = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (this.phone && !reg_phone.test(this.phone)) {
        dsf.layer.message('请输入正确手机号码', false);
        return
      }
      this.sumbitData()
    },
    sumbitData() {
      let weekValue = [];
      let timeValue = [];
      let placeValue = [];
      this.weekArr.forEach(element => {
        if (element.check) {
          weekValue.push({
            text: element.text,
            value: element.value
          })
        }
      })
      this.timeArr.forEach((element, index) => {
        timeValue.push({
          $index: index,
          $order: index,
          'resource_occupy_time.begin': element.stime + ':00',
          'resource_occupy_time.end': element.etime + ':00',
        })
      })
      this.placeArr.forEach(element => {
        placeValue.push({
          text: element.inheritName,
          value: element.id
        })
      })
      let dataString = {
        "resource_occupy.resource_type": {
          "value": "PLACE",
          "text": "地点"
        },
        "resource_occupy.business": {
          "text": "批量占用",
          "value": ""
        },
        "resource_occupy.business_type": {
          "text": "批量占用",
          "value": "4"
        },
        "resource_occupy.occupy": {
          "sdate": this.date.sdate + " 00:00:00",
          "edate": this.date.edate + " 23:59:59"
        },
        "resource_occupy.repeat": [...weekValue],
        "resource_occupy_time": [...timeValue],
        "resource_occupy.resource": [...placeValue],
        "resource_occupy.reason": this.reason,
        "resource_occupy.contact_text": this.contact_text,
        "resource_occupy.phone": this.phone,
      }
      let data = {
        data: JSON.stringify(dataString)
      }
      this.$http.post(this.sourcesUrl, data)
        .done((res) => {
          if (res.success && res.state == 20000) {
            dsf.layer.message("保存成功", true);
            this.$emit('sure', res)
          } else {
            dsf.layer.message(res.message || '请求出错', false)
          }
        })
        .error(function (err) {
          dsf.layer.message(err.message || "请求异常", false)
        })
    }
  }

})
</script>

<style>
</style>